var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.clazz,style:(_vm.style)},[(_vm.img)?_c('badgeWidget',{attrs:{"img":_vm.img}}):_vm._e(),_vm._l((_vm.config.elements),function(element){return _c(_vm.getComponentName(element),{key:element.id,tag:"component",attrs:{"config":element}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }